module.exports = "/virtual-football-league/img/amblems/right/Germany/Fake_Schalke.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Germany/Fake_Schalke.png
// module id = 2142
// module chunks = 4